import { EnvironmentEntry } from "@visioni/a3s-environments";
import { environments, platform } from "./build";
import { match } from "ts-pattern";

// TODO: Split into different hooks, compose them together.

/**
 * Get the build-time default environment.
 * For runtime environment (which may be changed), use getEnvironment() from environment-store.
 */
export const environment = () => environments.available[environments.default];

export const directory = (env: EnvironmentEntry) => `https://${env.fqdn}`;

export const authorization = (env: EnvironmentEntry) => ({
  domain: env.authDomain,
  audience: env.authAudience,
  clientId: env.authClientId,
  // These are a contract:
  // - registered Vision Auth (complete callback path)
  //   https://gitlab.com/visioni/teams/coredev/vision-auth/-/blob/main/auth0.py
  // - web stack deployment (base path '/app')
  //   apps/a3s-cloud/lib/realm-web-stack.ts
  redirectUri: match(platform)
    .with({ kind: "web" }, () => `${window.location.origin}/app/sign-in/callback`)
    .with(
      { kind: "ios" },
      (cfg) => `${cfg.scheme}://${env.authDomain}/${cfg.kind}/${cfg.ios.bundleIdentifier}/callback`,
    )
    .with({ kind: "android" }, (cfg) => `${cfg.scheme}://${env.authDomain}/${cfg.kind}/${cfg.android.package}/callback`)
    .exhaustive(),
  discovery: {
    authorizationEndpoint: `https://${env.authDomain}/authorize`,
    tokenEndpoint: `https://${env.authDomain}/oauth/token`,
  },
});
